import * as moment from 'moment';

import { BaseEntity, MemoizeGetters, Transform, toEntity } from './base';
import { TruckModel } from './truck';

export enum ShiftName {
  Day = 'day',
  Morning = 'morning',
  Night = 'night',
  LateNight = 'late_night',
}

export interface ShiftTime {
  hour: number;
  minute: number;
}

export interface ShiftETA {
  etaStart: string;
  etaEnd: string;
  eta: string;
}

export const MIN_REQUEST_WINDOW = 4;

@MemoizeGetters
export class ShiftModel extends BaseEntity {
  title: ShiftName;
  dayIndex: number;
  startTime: ShiftTime;
  endTime: ShiftTime;

  @Transform(toEntity(TruckModel))
  truck: TruckModel;

  get formattedTitle(): string {
    return `All ${this.title} (${ShiftModel.timeStringForHour(
      this.startTime.hour
    )}-${ShiftModel.timeStringForHour(this.endTime.hour)})`;
  }

  get shiftAvailableToday() {
    let today = moment();
    if (today.day() === this.dayIndex) {
      let currentHour = today.hour();
      return this.endTime.hour - currentHour > MIN_REQUEST_WINDOW;
    }
    return true;
  }

  static defaultStartTime(window: ShiftName): ShiftTime {
    switch (window) {
      case ShiftName.Day:
        return { hour: 9, minute: 0 };
      case ShiftName.Morning:
        return { hour: 5, minute: 0 };
      case ShiftName.Night:
        return { hour: 18, minute: 0 };
      case ShiftName.LateNight:
        return { hour: 0, minute: 0 };
      default:
        return { hour: 9, minute: 0 };
    }
  }

  static defaultEndTime(window: ShiftName): ShiftTime {
    switch (window) {
      case ShiftName.Day:
        return { hour: 17, minute: 0 };
      case ShiftName.Morning:
        return { hour: 9, minute: 0 };
      case ShiftName.Night:
        return { hour: 23, minute: 0 };
      case ShiftName.LateNight:
        return { hour: 5, minute: 0 };
      default:
        return { hour: 17, minute: 0 };
    }
  }

  static timeStringForHour(hour) {
    let ampmString = hour <= 11 ? 'am' : 'pm';
    let hourString = hour <= 12 ? hour : hour - 12;
    return hourString + ampmString;
  }
}



// WEBPACK FOOTER //
// ./src/models/shift.ts